import type { IncomeResponse } from './types.d';

// Helper functions to reduce duplication
const createFile = (id: string, fileName: string, sourceFileId: string) => ({
  id,
  sourceFileId,
  fileName,
  fileType: 'application/pdf',
  storagePath: `/files/${id}`,
  uploadedAt: '2024-01-15T10:00:00.000Z',
  storageUrl: `https://example.com/files/${id}`,
});

const createMetadataItem = (id: string, name: string, value: string) => ({
  id,
  name,
  value,
  source: null,
  createdAt: '2024-01-15T10:00:00.000Z',
});

const createAlert = (
  id: string,
  alertType: string,
  description: string,
  suggestedDocumentReview: string,
) => ({
  id,
  transactionId: '550e8400-e29b-41d4-a716-446655440000',
  candorId: 'candor-001',
  alertType,
  description,
  suggestedDocumentReview,
  createdAt: '2024-01-15T10:00:00.000Z',
});

export const mockIncomeData: IncomeResponse = {
  success: true,
  data: {
    files: [
      createFile('file-001', 'TEST241154690_borrower_needs.pdf', 'source-001'),
      createFile('file-002', 'TEST241154690_findings.pdf', 'source-002'),
      createFile('file-003', 'TEST241154690_liv.pdf', 'source-003'),
      createFile(
        'file-004',
        'TEST241154690_documents_processed.pdf',
        'source-004',
      ),
      createFile('file-005', 'TEST241154690_preview.pdf', 'source-005'),
    ],
    transactionId: '550e8400-e29b-41d4-a716-446655440000',
    status: 'finished',
    income_clarity_lines: [
      {
        id: 'line-001',
        transactionId: '550e8400-e29b-41d4-a716-446655440000',
        borrower: 'Andy America',
        employerName: 'Florida State High School',
        document: 'Paystub',
        incomeType: 'Base',
        income: '3500.0',
        createdAt: '2024-01-15T10:00:00.000Z',
        metadata: [
          createMetadataItem(
            'meta-001',
            'employer',
            'Florida State High School',
          ),
          createMetadataItem('meta-002', 'position', 'Teacher'),
          createMetadataItem('meta-003', 'pay_frequency', 'SemiMonthly'),
          createMetadataItem('meta-004', 'base_pay_rate', '0.0'),
          createMetadataItem('meta-005', 'base_pay_hours', '86.67'),
        ],
      },
    ],
    income_clarity_alerts: [
      createAlert(
        'alert-001',
        'Document Review',
        'Additional documentation may be required for income verification',
        'Please review paystub documentation',
      ),
      createAlert(
        'alert-002',
        'Income Calculation',
        'Income calculation completed successfully',
        'All income sources have been processed',
      ),
    ],
  },
};
